import {InputType, FormControlType, IFormConfig} from 'marine-panel-common-web';

export const marinaRestaurantsFormConfig = (value?: any): IFormConfig => {
    return {
        controlType: 'form',
        class: 'default-form',
        dataAccessor: (data: any) => data,
        outputDataMapper: (data: any, previousStateSnapshot: any) => {
            Object.assign(previousStateSnapshot, data);
            return previousStateSnapshot;
        },
        controls: [
            {
                key: 'marina_restaurants',
                controlType: 'group',
                class: 'row',
                controls: {
                    restaurants: {
                        controlType: 'control',
                        defaultValue: value ? value : '',
                        formControlType: FormControlType.TEXTAREA,
                        validationRules: [],
                        placeholder: '',
                        isLabelHidden: false,
                        label: '',
                        type: InputType.TEXT,
                        hostClass: 'col-xl-12 form-control',
                    },
                },
            },
        ],
    };
};
